module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "订单号",
      "size": "mini"
    },
    model: {
      value: (_vm.orderNo),
      callback: function($$v) {
        _vm.orderNo = $$v
      },
      expression: "orderNo"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "start-placeholder": "开始时间",
      "ange-separator": "至",
      "end-placeholder": "结束时间",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.timeRange),
      callback: function($$v) {
        _vm.timeRange = $$v
      },
      expression: "timeRange"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('div', {
    staticClass: "btn-2"
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 200
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "width": "160",
      "label": "订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceName",
      "label": "服务名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nursingIoCation",
      "label": "症状描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "患者姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址信息"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payTime",
      "label": "支付时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zfje",
      "label": "支付金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "surcharge",
      "label": "附加费用"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "surpayTime",
      "label": "附加费支付时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderState",
      "label": "状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.orderState == 0) ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("0待支付")]) : (scope.row.orderState == 1) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("待接单")]) : (scope.row.orderState == 2) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("无人接单")]) : (scope.row.orderState == 3) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("确认医嘱")]) : (scope.row.orderState == 4) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("已接单")]) : (scope.row.orderState == 5) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("待评价")]) : (scope.row.orderState == 6) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("已完成")]) : (scope.row.orderState == 7) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("申请撤销")]) : (scope.row.orderState == 8) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("已撤销")]) : (scope.row.orderState == 9) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("已取消")]) : (scope.row.orderState == 10) ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("已失效")]) : _c('el-tag', [_vm._v("1")])]
      }
    }], null, false, 781188112)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.dialogOpen(scope.row.orderNo, scope.row.orderState)
            }
          }
        }, [_vm._v("查询状态")])], 1)]
      }
    }], null, false, 1648034553)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5bc1d7c8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bc1d7c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/ywmdd.vue
// module id = 2747
// module chunks = 0